import React from "react";
import { AiOutlineDownload } from "react-icons/ai";

import $ from 'jquery'; 


export default class DownloadTable extends React.Component {
  
    constructor(props) {
        super(props);
        this.url = props.url;
        this.table_name = props.table_name;
        this.filename = props.filename;

        this.state = {
            downloadingTable: false,
        }
    }

    downloadingMessage = () => {

        this.setState({downloadingTable: true});

        setTimeout(()=>{
            this.setState({downloadingTable: false});
        }, 30000)

    }

    render() {        
        return (

            <div className="download-table-div">
                <a className="download-table" href={this.url} onClick={this.downloadingMessage}>
                    <AiOutlineDownload/>
                    <p>Download {this.table_name}</p>
                </a>
                { this.state.downloadingTable ? 
                    <p className="download-message">Downloading... can take up to 30 seconds</p>
                    :
                    ''
                }
            </div>
        )
    }
}
